import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getUserPoolTransactions, GetUserPoolTransactionsParams} from '../api';
import {QUERY__USER_POOL_TRANSACTIONS} from '../queryKeys';
import {Transaction} from '../types';

export const useGetUserPoolTransactions = <
  SelectedData = GetListOutput<Transaction>,
>(
  params: GetUserPoolTransactionsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__USER_POOL_TRANSACTIONS, params],
    queryFn: () => getUserPoolTransactions(params),
    ...options,
  });
};
